import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SearchWithResultsSpotController } from './search-with-results-spot/search-with-results-spot.controller';
import { SearchResultsComponent } from './search-results/search-results';
import { SearchBoxComponent } from './search-box/search-box';
import { CoveoSearchService } from './services/coveo-search.service';
var moduleId = 'gn.audio.support.search';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('SearchWithResultsSpotController', SearchWithResultsSpotController);
var SearchModule = (function () {
    function SearchModule() {
    }
    SearchModule = __decorate([
        NgModule({
            declarations: [
                SearchResultsComponent,
                SearchBoxComponent,
            ],
            id: moduleId,
            imports: [legacyModuleId],
            providers: [CoveoSearchService],
        })
    ], SearchModule);
    return SearchModule;
}());
export { SearchModule };
